module.exports = __webpack_public_path__ + "img/call.d8dffee2.jpg";